// Logica condivisa del "simbolo del giorno": identica tra Home e sezione Simboli.
// Entrambe leggono la stessa fonte dati (/symbols, ordinata per order,name).
export function getDaySymbol(symbols) {
  if (!symbols || symbols.length === 0) return null;
  return symbols[new Date().getDate() % symbols.length];
}

// Frasi evocative brevi per la scheda in evidenza, coerenti con il tono dell'app.
const EVOCATIVE = {
  acqua: "Lascia scorrere ciò che senti.",
  albero: "Radici salde, crescita gentile.",
  farfalla: "Un cambiamento che diventa volo.",
  fiore: "Concediti il tempo di sbocciare.",
  fuoco: "Ciò che ti accende chiede ascolto.",
  fuoco_spirito: "Una luce interiore che non consuma.",
  gatto: "Fidati di ciò che senti.",
  luna: "Onora anche i tuoi silenzi.",
  ponte: "Una distanza può diventare incontro.",
  porta: "Davanti a te, una soglia da attraversare.",
  sentiero: "Ogni piccolo passo apre il cammino.",
  sole: "Lasciati vedere alla luce.",
  uccello: "Guarda le cose da più in alto.",
};

export function evocativePhrase(symbol) {
  if (!symbol) return "";
  return EVOCATIVE[symbol.key] || (symbol.keywords || []).slice(0, 3).join(" · ");
}
